import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobOfferService } from 'src/app/core/services/job-offer/job-offer.service';
import { TenderService } from 'src/app/core/services/tender/tender.service';

@Component({
  selector: 'app-dossier-candidature',
  templateUrl: './dossier-candidature.component.html',
  styleUrls: ['./dossier-candidature.component.css']
})
export class DossierCandidatureComponent {
  id = this.activatedRoute.snapshot.params['id'];
  idoffer = this.activatedRoute.snapshot.params['id_offer'];
  candidaturedetails:any

  constructor(
    private activatedRoute: ActivatedRoute,
    private tenderservice: TenderService,
    private spinner: NgxSpinnerService,
 
  ) {}
  ngOnInit() {
    this.getcandidaturebyid();

  }

  /* get job offer details */
  getcandidaturebyid() {
    this.spinner.show();
    this.tenderservice.getcandidatureById(this.id,this.idoffer).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('res detail job offer', res);
        this.candidaturedetails = res.data[0];
       
        console.log('detail job offer', this.candidaturedetails);
      },
      error: () => {},
    });
  }
}
